import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { getLocalizedString } from "@icarius-localization/strings";
import { CloseIcon } from "@icarius-icons";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid,
  TextField,
  Chip,
  Checkbox,
} from "@material-ui/core";
import DialogTitleDivider from "@icarius-common/dialogTitleDivider";
import ButtonDialogAction from "@icarius-common/buttonDialogAction";
import PaperDraggable from "@icarius-common/paperDraggable";
import DialogTransition from "@icarius-common/dialogTransition";
import Loader from "@icarius-common/loader";
import { Autocomplete } from "@material-ui/lab";
import CancelIcon from '@material-ui/icons/Cancel';
import { addConceptsEntryPerConceptAction, getEntryPerConcept } from "@icarius-pages/assetsDiscountsEntryPerConcept/actions";

const AddConceptStructureDialog = (props) => {

  const {
    open,
    entryStructure,
    options,
    selected,
    isLoading,
    handleClose,
  } = props;

  const dispatch = useDispatch();
  const [structureConcepts, setStructureConcepts] = useState(() => options.filter((option) => selected.includes(option.key)))

  const submit = () => {
    dispatch(addConceptsEntryPerConceptAction({ entryStructure, structureConcepts: structureConcepts.map((item) => item.key) }))
      .then((resp) => {
        if (resp.status === 200) {
          dispatch(getEntryPerConcept(entryStructure));
          handleClose()
        }
      })
  }

  return (
    <Dialog
      open={open}
      TransitionComponent={DialogTransition}
      PaperComponent={PaperDraggable}
      maxWidth={"sm"}
      fullWidth={true}
    >
      <div className={"dialog-container"}>
        <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
          {getLocalizedString("addConcepts")}
          <DialogTitleDivider />
        </DialogTitle>
        <CloseIcon className={"dialog-close-icon icon"} onClick={handleClose} />
        <DialogContent>
          <Loader open={isLoading} />
          <Grid container item xs={12}>
            <Grid container item alignItems="center" xs={12}>
              <Autocomplete
                fullWidth
                multiple
                options={options}
                value={structureConcepts}
                disableCloseOnSelect
                onChange={(e, newConcepts) => setStructureConcepts(newConcepts)}
                closeText=""
                openText=""
                clearOnBlur
                disableClearable
                noOptionsText={''}
                getOptionLabel={(option) => option.value}
                renderTags={(value, getTagProps) =>
                  value.map((option, index) => {
                    return (
                      <Chip
                        variant="outlined"
                        label={option.value}
                        style={{ color: "var(--mainText)", borderColor: "var(--mainText)", margin: 5 }}
                        onDelete={getTagProps({ index }).onDelete}
                        deleteIcon={<CancelIcon style={{ color: 'var(--mainText)' }} />}
                      />
                    )
                  })
                }
                renderInput={(params) => <TextField {...params} label={getLocalizedString("concepts")} />}
                renderOption={(option, { selected }) => (
                  <>
                    <Checkbox
                      style={{ marginRight: 8 }}
                      checked={selected}
                    />
                    {option.value}
                  </>
                )}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <ButtonDialogAction onClick={handleClose} text={getLocalizedString("cancel")} />
          <ButtonDialogAction onClick={submit} isAccept text={getLocalizedString("accept")} />
        </DialogActions>
      </div>
    </Dialog>
  );
}

export default AddConceptStructureDialog;